import constants from '../constants';

const getDetachedChildrenArray = (globalElement) => {
  const detachedChildren = globalElement.getAttribute(
    constants.attributes.DETACHED_CHILDREN_GLOBAL
  );

  return detachedChildren ? detachedChildren.split(' ') : [];
};

export default getDetachedChildrenArray;
